import { DataFile, Dataset } from './DataFile.js';
import { IDataFileVisitor } from './IDataFileVisitor.js';

export class DatasetList {
  constructor(private readonly datasets: Dataset[]) {
  }

  accept(visitor: IDataFileVisitor): void {
    visitor.beforeAll();
    for (const dataset of this.datasets) {
      for (const doc of dataset) {
        const dataFile = new DataFile(doc);
        dataFile.accept(visitor);
      }
    }
    visitor.afterAll();
  }
}